Vendd.Scripts.load(function () {

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    var $wrapper = $('.x-newsletter-popup');

    if ($wrapper.length < 1 || !funcCookiesEnabled)
        return;

    if ($('.touch').length <= 0) {
        // InitPromoPopUp();
    }

    InitNewsletterPopup();

    function InitNewsletterPopup() {
        var $fancyButton = $('a[href="#newsletterPopup"]');

        if (!$fancyButton.length > 0)
            return;

        $fancyButton.fancybox({
            baseClass: "newsletterPopup",
            helpers: {
                overlay: {
                    locked: true,
                }
            },
            touch: false,
            btnTpl: {
                smallBtn: '<a title="Close" data-fancybox-close class="fancybox-button fancybox-close-small fancybox-close icon-exit2 stylish-fancy-close" href="javascript:;"></a>'
            },
            afterLoad: function () {
                $('.site-container').addClass('has-filter');
            },
            afterClose: function () {
                $('.site-container').removeClass('has-filter');
            }
        });
    }

    function InitPromoPopUp() {

        var cookiesAccepted = window.ConsentsManager.cookiesStatus.userHasSetCookies;
        var promo = getCookie("promo");

        if (!promo && cookiesAccepted && $('.terms-page.consents-page').length <= 0) {
            $(".open-fancy-promo", $wrapper).fancybox({
                padding: 0,
                margin: [50, 0, 0, 0],
                width: 705,
                height: 'auto',
                topRatio: 0,
                closeBtn: false,
                fitToView: true,
                autoSize: false,
                helpers: {
                    overlay: {
                        closeClick: false
                    }
                },
                afterClose: function () {
                    setCookie("promo", true, 5);
                }
            });
            $(".open-fancy-promo", $wrapper).trigger("click");
            $('.newsletter-popup .close-button').click(function () {
                $.fancybox.close();
            });
        }
    }

});